// Combo's chart inputs. The family's chart draws a resolved tag list; combo's draws the
// question's own answer tree and the level the drill-down points at, so it needs the tree, the
// scope and the way back up -- and, for the single-level plain chart, the trait it splits by.

import { calcChartProps as calcOeChartProps } from '@aytm/app/stats/page/question-views/oe/lib/props/chart'

export const calcChartProps = inputs => {
  const { viewMode, scope, answer, answerVariants, format, trait, traitName, handlers = {} } = inputs

  return {
    ...calcOeChartProps(inputs),
    viewMode,
    scope,
    answer,
    answerVariants,
    format,
    trait,
    traitName,
    onScopeChange: handlers.onScopeChange
  }
}
